import { postApi } from '../api/digitalVault';
export default ({ folderName, repositoryName, path }, logger) => {
    const query = new URLSearchParams();
    query.append('name', folderName);
    query.append('path', path);
    return postApi(query, `repository/${repositoryName}/folder`, {}, logger);
};
